<ion-content class="upsell-opp">
    <ng-container>
        <app-header [title]="stopName + ' Upsell Opp.'"></app-header>
        <ion-grid>
        </ion-grid>
    </ng-container>
</ion-content>